module.exports = __webpack_public_path__ + "assets/acd3ebe05009396cf31a6b7b12522bb8.png";